import React from 'react';
import classnames from 'classnames';
import { useHtmlIDs } from 'hellospa/common/hooks';
import { PREPARER } from '../constants';
import styles from './checkbox.scss';

const NOOP = () => {};

function Checkbox({
  fieldData, textScale, onChange, isActive, selectField, disabled,
  updateFields, validationErrors, height, width,
  getInstantValidationErrorHack, ...props
}, ref) {
  const htmlId = useHtmlIDs();
  const checked = Boolean(fieldData.signer === PREPARER || fieldData.checked);
  const readOnly = fieldData.readOnly || false;

  return (
    <React.Fragment>
      <input
        type="checkbox"
        id={htmlId('checkbox')}
        onChange={(fieldData.signer === PREPARER) ? NOOP : onChange}
        checked={checked || false}
        className={styles.input} />
      <label htmlFor={htmlId('checkbox')} data-qa-ref="checkbox-label">
        <div
          ref={ref}
          tabIndex={readOnly ? -1 : 0}
          {...props}
          className={classnames(props.className, styles.checkbox, {
            [styles.checked]: checked,
          })} />
      </label>
    </React.Fragment>
  );

}

export default React.memo(React.forwardRef(Checkbox));
